import useProtoMethod from "./useProtoMethod";
import {
  GetOrCreateSessionRequest,
  GetOrCreateSessionResponse,
  GetSubmissionRequest,
  GetSubmissionResponse,
  ListSubmissionsRequest,
  ListSubmissionsResponse,
  RespondToAssignmentRequest,
  RespondToAssignmentResponse,
  SendAssignmentOpportunitiesRequest,
  SendAssignmentOpportunitiesResponse,
  SignupSubmissionRequest,
  SignupSubmissionResponse,
  UpdateSessionRequest,
  UpdateSessionResponse,
  UpdateSubmissionRequest,
  UpdateSubmissionResponse,
  GetSignupPaymentLinkRequest,
  GetSignupPaymentLinkResponse,
  ListAssignmentCandidatesResponse,
  ListAssignmentCandidatesRequest,
  ExtendAssignmentExpirationRequest,
  ExtendAssignmentExpirationResponse,
  ManuallyAssignAdvisorRequest,
  ManuallyAssignAdvisorResponse,
  GetCheckoutSessionRequest,
  GetCheckoutSessionResponse,
  GetSignupSessionForMemberResponse,
  GetSignupSessionForMemberRequest,
  ResolveExistingAccountConflictRequest,
  ResolveExistingAccountConflictResponse,
} from "../protogen/signup_service_pb";

const useGetOrCreateSession = (
  callback?: (r: GetOrCreateSessionResponse) => void,
) => {
  return useProtoMethod<GetOrCreateSessionRequest, GetOrCreateSessionResponse>(
    "GetOrCreateSession",
    GetOrCreateSessionResponse,
    { callback },
  );
};

const useUpdateSession = (callback?: (r: UpdateSessionResponse) => void) => {
  return useProtoMethod<UpdateSessionRequest, UpdateSessionResponse>(
    "UpdateSession",
    UpdateSessionResponse,
    { callback, rethrowClientErrors: true },
  );
};

const useSignupSubmission = (
  callback?: (r: SignupSubmissionResponse) => void,
) => {
  return useProtoMethod<SignupSubmissionRequest, SignupSubmissionResponse>(
    "SignupSubmission",
    SignupSubmissionResponse,
    { callback },
  );
};

const useSignupSubmissionByMember = (
  callback?: (r: SignupSubmissionResponse) => void,
) => {
  return useProtoMethod<SignupSubmissionRequest, SignupSubmissionResponse>(
    "SignupSubmissionByMember",
    SignupSubmissionResponse,
    { callback },
  );
};

const useListSubmissions = (
  callback?: (r: ListSubmissionsResponse) => void,
) => {
  return useProtoMethod<ListSubmissionsRequest, ListSubmissionsResponse>(
    "ListSubmissions",
    ListSubmissionsResponse,
    { callback },
  );
};

const useGetSubmission = (callback?: (r: GetSubmissionResponse) => void) => {
  return useProtoMethod<GetSubmissionRequest, GetSubmissionResponse>(
    "GetSubmission",
    GetSubmissionResponse,
    { callback },
  );
};

const useUpdateSubmission = (
  callback?: (r: UpdateSubmissionResponse) => void,
) => {
  return useProtoMethod<UpdateSubmissionRequest, UpdateSubmissionResponse>(
    "UpdateSubmission",
    UpdateSubmissionResponse,
    { callback },
  );
};

const useGetSignupPaymentLink = (
  callback?: (r: GetSignupPaymentLinkResponse) => void,
) => {
  return useProtoMethod<
    GetSignupPaymentLinkRequest,
    GetSignupPaymentLinkResponse
  >("GetSignupPaymentLink", GetSignupPaymentLinkResponse, { callback });
};

const useSendAssignmentOpportunities = (
  callback?: (r: SendAssignmentOpportunitiesResponse) => void,
) => {
  return useProtoMethod<
    SendAssignmentOpportunitiesRequest,
    SendAssignmentOpportunitiesResponse
  >("SendAssignmentOpportunities", SendAssignmentOpportunitiesResponse, {
    callback,
    rethrowClientErrors: true,
  });
};

const useRespondToAssignment = (
  callback?: (r: RespondToAssignmentResponse) => void,
) => {
  return useProtoMethod<
    RespondToAssignmentRequest,
    RespondToAssignmentResponse
  >("RespondToAssignment", RespondToAssignmentResponse, { callback });
};

const useListAssignmentCandidates = (
  callback?: (r: ListAssignmentCandidatesResponse) => void,
) => {
  return useProtoMethod<
    ListAssignmentCandidatesRequest,
    ListAssignmentCandidatesResponse
  >("ListAssignmentCandidates", ListAssignmentCandidatesResponse, { callback });
};

const useExtendAssignmentExpiration = (
  callback?: (r: ExtendAssignmentExpirationResponse) => void,
) => {
  return useProtoMethod<
    ExtendAssignmentExpirationRequest,
    ExtendAssignmentExpirationResponse
  >("ExtendAssignmentExpiration", ExtendAssignmentExpirationResponse, {
    callback,
  });
};

const useManuallyAssignAdvisor = (
  callback?: (r: ManuallyAssignAdvisorResponse) => void,
) => {
  return useProtoMethod<
    ManuallyAssignAdvisorRequest,
    ManuallyAssignAdvisorResponse
  >("ManuallyAssignAdvisor", ManuallyAssignAdvisorResponse, { callback });
};

const useGetCheckoutSession = (
  callback?: (r: GetCheckoutSessionResponse) => void,
) => {
  return useProtoMethod<GetCheckoutSessionRequest, GetCheckoutSessionResponse>(
    "GetCheckoutSession",
    GetCheckoutSessionResponse,
    { callback },
  );
};

const useUpdateSessionForMember = (
  callback?: (r: UpdateSessionResponse) => void,
) => {
  return useProtoMethod<UpdateSessionRequest, UpdateSessionResponse>(
    "UpdateSessionForMember",
    UpdateSessionResponse,
    { callback, rethrowClientErrors: true },
  );
};

const useGetSignupSessionForMember = (
  callback?: (r: GetSignupSessionForMemberResponse) => void,
) => {
  return useProtoMethod<
    GetSignupSessionForMemberRequest,
    GetSignupSessionForMemberResponse
  >("GetSignupSessionForMember", GetSignupSessionForMemberResponse, {
    callback,
  });
};

const useResolveExistingAccountConflict = (
  callback?: (r: ResolveExistingAccountConflictResponse) => void,
) => {
  return useProtoMethod<
    ResolveExistingAccountConflictRequest,
    ResolveExistingAccountConflictResponse
  >("ResolveExistingAccountConflict", ResolveExistingAccountConflictResponse, {
    callback,
  });
};

const useSendExistingAccountConflictEmail = (
  callback?: (r: ResolveExistingAccountConflictResponse) => void,
) => {
  return useProtoMethod<
    ResolveExistingAccountConflictRequest,
    ResolveExistingAccountConflictResponse
  >(
    "SendExistingAccountConflictEmail",
    ResolveExistingAccountConflictResponse,
    {
      callback,
      rethrowClientErrors: true,
    },
  );
};

export {
  useGetOrCreateSession,
  useUpdateSession,
  useSignupSubmission,
  useSignupSubmissionByMember,
  useListSubmissions,
  useUpdateSubmission,
  useGetSignupPaymentLink,
  useGetSubmission,
  useSendAssignmentOpportunities,
  useRespondToAssignment,
  useListAssignmentCandidates,
  useExtendAssignmentExpiration,
  useManuallyAssignAdvisor,
  useGetCheckoutSession,
  useUpdateSessionForMember,
  useGetSignupSessionForMember,
  useResolveExistingAccountConflict,
  useSendExistingAccountConflictEmail,
};
